import React from "react";
import { Award } from "lucide-react";
import { SectionHeader } from "./About";

export default function Certifications({ items }) {
  // Duplicate for seamless marquee loop
  const loop = [...items, ...items];
  return (
    <section id="certifications" className="py-24 md:py-32 relative" data-testid="certifications-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <SectionHeader
           number="06"
          overline="Certifications"
          title={`${items.length} certs. CKA · CKS · CKAD · IBM · IIM · Azure.`}
        />
      </div>
      <div className="mt-14 overflow-hidden relative">
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-ink-950 to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-ink-950 to-transparent z-10 pointer-events-none" />
        <div className="flex gap-4 animate-marquee whitespace-nowrap will-change-transform" style={{ width: "max-content" }}>
          {loop.map((c, i) => (
            <div
              key={i}
              className="inline-flex items-center gap-3 border border-white/10 px-5 py-3 bg-ink-900 hover:border-volt transition-colors"
              data-testid={`cert-chip-${i}`}
            >
              <Award className="w-4 h-4 text-volt" />
              <span className="text-sm text-fog-200">{c.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
